import React, { useMemo } from 'react';
import { Loader2 } from 'lucide-react';
import { mergeProductos, computeHeroKpis, buildAutoObservations } from '../../helpers/detergentesCalculations';
import HeroKpisSection from './HeroKpisSection';
import ProductoPorProductoSection from './ProductoPorProductoSection';
import ObservacionesDetergentesSection from './ObservacionesDetergentesSection';

// Contenido del reporte "Detergentes y Químicos". Recibe el hook ya instanciado desde la
// página padre (mismo patrón que LotesVsCiclosContent.jsx) y hace el merge real↔teórico.
const DetergentesQuimicosContent = ({ detergentes, toleranciaPct }) => {
  const { data, loading, error } = detergentes;

  const merged = useMemo(() => {
    if (!data) return [];
    return mergeProductos({
      productosTotales: data.teorico.productosTotales,
      real: data.real,
      costosPorLitro: data.costosTeoricos,
      toleranciaPct,
    });
  }, [data, toleranciaPct]);

  const heroKpis = useMemo(() => {
    if (!data) return null;
    return computeHeroKpis(merged, data.teorico.kilosProcesados);
  }, [merged, data]);

  const observaciones = useMemo(() => {
    if (!heroKpis) return [];
    return buildAutoObservations(merged, heroKpis);
  }, [merged, heroKpis]);

  if (error) {
    return (
      <div className="bg-red-50 dark:bg-red-900/20 text-red-700 dark:text-red-300 text-sm rounded-xl p-4">
        {error}
      </div>
    );
  }

  if (loading || !data) {
    return (
      <div className="space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {[0, 1, 2].map((i) => (
            <div key={i} className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200/80 p-5 h-32 animate-pulse" />
          ))}
        </div>
        <div className="flex items-center justify-center py-10 text-sm text-gray-500 dark:text-gray-400">
          <Loader2 className="h-4 w-4 animate-spin mr-2" /> Cargando consumo de detergentes y químicos…
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <HeroKpisSection heroKpis={heroKpis} />
      <ProductoPorProductoSection
        merged={merged}
        productosPorPrograma={data.teorico.productosPorPrograma}
        litrosTeoricoTotal={heroKpis.litrosTeoricoTotal}
      />
      <ObservacionesDetergentesSection observaciones={observaciones} />
    </div>
  );
};

export default DetergentesQuimicosContent;
